<template>
  <section class='section'>
    <!-- Header -->
    <div class='is-flex is-justify-center'>
      <div class="field has-addons" style='margin-bottom: 35px'>
        <p class="control">
          <a class="button" :class='section === "survey" ? "is-link" : "" ' style='width: 125px' v-on:click='changeSection("survey")'>
            <span>Encuesta</span>
          </a>
        </p>
        <p class="control">
          <a class="button" :class='section === "email" ? "is-link" : "" ' style='width: 125px' v-on:click='changeSection("email")'>
            <span>Correo</span>
          </a>
        </p>
      </div>
    </div>

    <div v-if='section === "survey"'>
      <MessageSurvey :proceso='proceso' :data='data.survey' :tokenUser='tokenUser' @getData='getData'></MessageSurvey>
    </div>
    <div v-if='section === "email"'>
      <MessageEmailSurvey :proceso='proceso' :data='data.email' :tokenUser='tokenUser' @getData='getData'></MessageEmailSurvey>
    </div>
  </section>
</template>
<script>
import apiServices from "@/services/yungol-services";
import MessageSurvey from './MessageSurvey.vue'
import MessageEmailSurvey from './MessageEmailSurvey.vue'
import {mapState} from 'vuex'
  export default {
    data(){
      return {
        section: 'survey',
        data:{}
      }
    },
    props:{
      proceso: {
        type: Object,
      },
      tokenUser:{
        type: Object,
      }
    },
    computed:{
      ...mapState(['idtoken'])
    },
    beforeMount() {
    },
    methods:{
      // Data
      async getData() {
        this.data = {
          survey: {
            lider: {
              title: "",
              cuerpo: ""
            },
            colaborador: {
              title: "",
              cuerpo: ""
            }
          },
          email: {
            liderEmail: {
              emailSubject: "",
              emailCuerpo: ""
            },
            colaboradorEmail: {
              emailSubject: "",
              emailCuerpo: ""
            }
          }
        }
        let id = {
          user_id: this.tokenUser.user_id,
          procesoId: this.proceso._id
        }
        const result = await apiServices.post('infoemail', id);
        if (result.data[0] && Object.values(result.data[0]).length > 6) {
          if (result.data[0].lider){
            // Carga de Títulos de la encuesta
            if (result.data[0].lider.title) this.data.survey.lider.title = result.data[0].lider.title
            // Carga de Cuerpo principal de la encuesta
            if (result.data[0].lider.cuerpo) this.data.survey.lider.cuerpo = result.data[0].lider.cuerpo
          }

          if (result.data[0].colaborador){
            // Carga de Títulos de la encuesta
            if (result.data[0].colaborador.title) this.data.survey.colaborador.title = result.data[0].colaborador.title
            // Carga de Cuerpo principal de la encuesta
            if (result.data[0].colaborador.cuerpo) this.data.survey.colaborador.cuerpo = result.data[0].colaborador.cuerpo
          }

          if (result.data[0].liderEmail){
            // Carga de Títulos del correo
            if (result.data[0].liderEmail.emailSubject) this.data.email.liderEmail.emailSubject = result.data[0].liderEmail.emailSubject
            // Carga de Cuerpo principal del correo
            if (result.data[0].liderEmail.emailCuerpo) this.data.email.liderEmail.emailCuerpo = result.data[0].liderEmail.emailCuerpo
          }

          if (result.data[0].colaboradorEmail){
            // Carga de Títulos del correo
            if (result.data[0].colaboradorEmail.emailSubject) this.data.email.colaboradorEmail.emailSubject = result.data[0].colaboradorEmail.emailSubject
            // Carga de Cuerpo principal del correo
            if (result.data[0].colaboradorEmail.emailCuerpo) this.data.email.colaboradorEmail.emailCuerpo = result.data[0].colaboradorEmail.emailCuerpo
          }
        }
      },
      // Components
      changeSection(section){
        this.section = section
      }
      // Helpers
    },
    created() {
      if (this.idtoken){
        this.getData()
      }
    },
    components:{
      MessageSurvey,
      MessageEmailSurvey
    }
  }
</script>
<style lang='scss'>
.textareaSettings{
  resize: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/Ajustes/Ajustes.vue